module.exports = __webpack_public_path__ + "static/media/language.721a190b.svg";